import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import fp from 'lodash/fp';
import { getTrades, getOriginalTrades } from './selectors';
import { getSummaryTrades, getSummaryOriginalTrades } from '../../impactAnalysisIdSummary/selectors';
import {
    setAllUnbookedTradesChecked, setTradeChecked, tradePricedTodayLoaded, submitBookingTrades
} from './actions';
import { viewTradeInPricingParams } from '../../pricingparameters/actions';
import TradePricedTodayView from './TradePricedTodayView';

class TradePriceToday extends React.Component {
    constructor(props) {
        super(props);
        this.setAllUnbookedTradesChecked = this.setAllUnbookedTradesChecked.bind(this);
        this.openBookTradesModal = this.openBookTradesModal.bind(this);
        this.closeBookTradesModal = this.closeBookTradesModal.bind(this);
        this.submitBooKTradesModal = this.submitBooKTradesModal.bind(this);
        this.openSingleTradeModal = this.openSingleTradeModal.bind(this);
        this.toggleTrade = this.toggleTrade.bind(this);
        this.setSearchString = this.setSearchString.bind(this);
        this.openUnbookTradesModal = this.openUnbookTradesModal.bind(this);
        this.submitUnbooKTradesModal = this.submitUnbooKTradesModal.bind(this);
        this.openDeleteTradesModal = this.openDeleteTradesModal.bind(this);
        this.submitDeleteTradesModal = this.submitDeleteTradesModal.bind(this);
        this.openSingleDeleteTradesModal = this.openSingleDeleteTradesModal.bind(this);
        this.state = {
            tradeIdTicked: false,
            searchString: '',
            showModal: false,
            trades: [],
            tradesProcess: '' // Book, Cancel, Delete
        };
    }

    componentDidMount() {
        this.props.tradePricedTodayLoaded();
    }

    setSearchString(searchString) {
        this.setState({ searchString });
    }

    setAllUnbookedTradesChecked(checked) {
        this.setState({ tradeIdTicked: checked });
        this.props.setAllUnbookedTradesChecked(checked);
    }

    openUnbookTradesModal(trade) {
        this.setState({
            trades: this.props.trades.map(t => (t.name === trade.name
                ? ({
                    ...t, visible: true, booked: false, confirmed: true
                })
                : ({ ...t, visible: false }))),
            showModal: true,
            tradesProcess: 'Cancel'
        });
    }

    openBookTradesModal() {
        this.setState({
            trades: this.props.trades.map(t => (t.selected
                ? ({ ...t, confirmed: true, visible: true })
                : ({ ...t, confirmed: false, visible: false }))),
            showModal: true,
            tradesProcess: 'Book'
        });
    }

    openSingleDeleteTradesModal(trade) {
        this.setState({
            trades: this.props.trades.map(t => (t.name === trade.name
                ? ({ ...t, confirmed: true, visible: true })
                : ({ ...t, confirmed: false, visible: false }))),
            showModal: true,
            tradesProcess: 'Delete'
        });
    }

    openDeleteTradesModal() {
        this.setState({
            trades: this.props.trades.map(t => (t.selected
                ? ({ ...t, confirmed: true, visible: true })
                : ({ ...t, confirmed: false, visible: false }))),
            showModal: true,
            tradesProcess: 'Delete'
        });
    }

    openSingleTradeModal(trade) {
        this.setState({
            trades: this.props.trades.map(t => (t.name === trade.name || t.booked
                ? ({ ...t, confirmed: true, visible: true })
                : ({ ...t, confirmed: false, visible: false }))),
            showModal: true,
            tradesProcess: 'Book'
        });
    }

    closeBookTradesModal() {
        this.setState({ trades: [], showModal: false });
    }

    submitBooKTradesModal() {
        const tradesRequest = this.state.trades.map(trade => ({
            name: trade.name,
            booked: trade.confirmed,
            selected: trade.selected,
            id: trade.id
        }));
        this.props.submitBookingTrades(tradesRequest);
        this.setState({ trades: [], showModal: false });
    }

    submitUnbooKTradesModal() {
        const tradesRequest = this.state.trades.map(trade => ({
            name: trade.name,
            booked: trade.confirmed ? false
                : this.props.trades.find(t => t.name === trade.name).booked,
            selected: trade.selected,
            id: trade.id
        }));
        this.props.submitBookingTrades(tradesRequest);
        this.setState({ trades: [], showModal: false });
    }

    submitDeleteTradesModal() {
        const tradesRequest = this.state.trades.filter(trade => trade.booked
             || !trade.confirmed).map(trade => ({
            name: trade.name,
            booked: trade.booked,
            selected: trade.selected,
            id: trade.id
        }));
        this.props.submitBookingTrades(tradesRequest);
        this.setState({ trades: [], showModal: false });
    }

    toggleTrade(checked, id) {
        this.setState(prevState => ({
            trades: prevState.trades.map(trade => (trade.name === id
                ? fp.set('confirmed', checked, trade) : trade))
        }));
    }

    render() {
        const trades = this.props.readOnly ? this.props.summaryTrades : this.props.trades;
        const originalTrades = this.props.readOnly ? this.props.summaryOriginalTrades : this.props.originalTrades;

        return (
            <TradePricedTodayView
                closeModal={ this.closeBookTradesModal }
                modalIsOpen={ this.state.showModal }
                openBookTradesModal={ this.openBookTradesModal }
                openSingleTradeModal={ this.openSingleTradeModal }
                openSingleDeleteTradesModal={ this.openSingleDeleteTradesModal }
                openDeleteTradesModal={ this.openDeleteTradesModal }
                originalTrades={ originalTrades }
                process={ this.state.tradesProcess }
                searchString={ this.state.searchString }
                setSearchString={ this.setSearchString }
                setTradeChecked={ this.props.setTradeChecked }
                setTradeCheckedId={ this.setAllUnbookedTradesChecked }
                stateTrades={ this.state.trades }
                submitDeleteTradesModal={ this.submitDeleteTradesModal }
                submitModal={ this.submitBooKTradesModal }
                submitUnbooKTradesModal={ this.submitUnbooKTradesModal }
                toggleTrade={ this.toggleTrade }
                tradeIdTicked={ this.state.tradeIdTicked }
                trades={ trades }
                openUnbookTradesModal={ this.openUnbookTradesModal }
                viewTradeInPricingParams={ this.props.viewTradeInPricingParams }
                readOnly={ this.props.readOnly }
            />
        );
    }
}

TradePriceToday.propTypes = {
    originalTrades: PropTypes.arrayOf(PropTypes.shape({})),
    summaryOriginalTrades: PropTypes.arrayOf(PropTypes.shape({})),
    setAllUnbookedTradesChecked: PropTypes.func.isRequired,
    setTradeChecked: PropTypes.func.isRequired,
    submitBookingTrades: PropTypes.func.isRequired,
    trades: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            checked: PropTypes.bool,
            booked: PropTypes.bool
        })
    ),
    summaryTrades: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            checked: PropTypes.bool,
            booked: PropTypes.bool
        })
    ),
    tradePricedTodayLoaded: PropTypes.func.isRequired,
    viewTradeInPricingParams: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
};

TradePriceToday.defaultProps = {
    originalTrades: [],
    trades: [],
    summaryOriginalTrades: [],
    summaryTrades: [],
    readOnly: false
};

const mapStateToProps = state => ({
    originalTrades: getOriginalTrades(state),
    trades: getTrades(state),
    summaryOriginalTrades: getSummaryOriginalTrades(state),
    summaryTrades: getSummaryTrades(state)
});

const mapDispatchToProps = {
    setAllUnbookedTradesChecked,
    setTradeChecked,
    submitBookingTrades,
    tradePricedTodayLoaded,
    viewTradeInPricingParams
};

export default withRouter(connect(mapStateToProps,
    mapDispatchToProps)(TradePriceToday));

export { TradePriceToday as TradePriceTodayUnconnected };
